import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import styles from './QuestionItem.module.scss';
import CheckIcon from "./CheckIcon";

export const QuestionItem = (props) => {
  const {title, question} = props;

  const replaceLinks = useCallback((text) => {
    return text.replace(
      new RegExp(/((http|https|ftp):\/\/[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/g),
      "<a href='$1' target='_blank'>$1</a>",
    );
  }, []);

  return (
    <div className={styles.container}>
      <CheckIcon className="text-primary"/>
      <h2>{title}</h2>
      {React.createElement('p', {
        dangerouslySetInnerHTML: {
          __html: replaceLinks(question)
        }
      })}
    </div>
  );
};

QuestionItem.propTypes = {
  title: PropTypes.string,
  question: PropTypes.string
}

QuestionItem.defaultProps = {}

export default QuestionItem;
